import CustomQuantity from './CustomQuantity';

export default CustomQuantity;
